import {Component} from 'react';
import PropTypes from 'prop-types';

import {appConfigService, fileTypeService} from '_app/services';
import {Enums, mergeClasses} from '_app/utils';
import './media-preview.less';

export default class MediaPreview extends Component {
	container() {
		const {type, showTypeIndicator, item, isCampaign, isCustomFile} = this.props;
		const containerStyle = {};
		const url = (isCampaign && item.Section === 1) ? '/Content/no_image_uploaded.png' : '/Content/no_thumb.png';
		const fallback = appConfigService.get('serverPath') + url;
		const imageUrl = this.getThumb();
		const containerClassList = mergeClasses(
			'media-preview-container',
			type
		);
		let contentTypeIndicator = null;
		let formMediaIcon = null;

		if (isCustomFile) {
			const fileType = item.Type;

			containerStyle.backgroundImage = `url("${appConfigService.get('serverPath') +
		    fileTypeService.getCustomFileImage(fileType)}")`;
		} else {
			if (imageUrl){
				if (type !== 'xxx-large') {
					containerStyle.backgroundColor = '#fff';
				} else {
					containerStyle.backgroundColor = '#ffffff00';
				}
				if ((imageUrl === 'null' || imageUrl === 'undefined')) {
					containerStyle.backgroundImage = `url("${fallback}")`;
				} else {
					containerStyle.backgroundImage = `url("${imageUrl}")`;
				}
				contentTypeIndicator = showTypeIndicator && this.formIcon();
			} else {
				if (isCampaign) {
					containerStyle.backgroundImage = `url("${fallback}"), url("${fallback}")`;
				} else {
					formMediaIcon = this.formMediaIcon();
				}
			}
		}

		return (
			<div className={containerClassList} style={containerStyle}>
				{!this.props.hideProducerIcon && this.formDecorator()}
				{contentTypeIndicator}
				{formMediaIcon}
				<span className="sr-only">Go to {item.Name}</span>
			</div>
		);
	}

	formDecorator() {
		const {item} = this.props;
		const decorator = fileTypeService.iconDecoratorForSource(item.SourceCode);
		const sourceLabel = Enums.getType('mediaSources').properties[item.SourceCode];
		const imgSource = item.SourceID === 2 ? appConfigService.get('serverPath') + '/Content/' + decorator : '';

		return (decorator !== null) &&
			<img
				src={imgSource}
				alt={sourceLabel ? sourceLabel.name + ' curated content' : null}
				className="external-content-img"
			/>;
	}

	formIcon() {
		const {item} = this.props;
		const types = Enums.getType('mediaTypes');
		const icon = fileTypeService.iconFromMedia(item);

		if (item.Type === types.PRESENTATION) {
			return (
				<div className="content-type-indicator presentation-type" style={{
					backgroundImage: `url("${appConfigService.get('serverPath')}Content/presentation_type.png")`
				}}
				/>
			);
		} else {
			return <i className={`content-type-indicator fa fa-${icon} fa-1x`} />;
		}
	}

	formMediaIcon() {
		const icon = fileTypeService.iconFromMedia(this.props.item);
		const iconSize = this.getIconSize();
		const thumbnailLinkUrl = this.getThumbnailLinkUrl();
		const types = Enums.getType('mediaTypes');

		if (thumbnailLinkUrl && this.props.item.Type === types.VIDEO && this.props.showPlayIcon) {
			return <i className={`fa fa-${iconSize}x fa-play-circle-o`} />;
		} else if (this.props.item.Media && this.props.item.Type === types.PRESENTATION) {
			return (
				<div className="presentation" style={{
					backgroundImage: `url("${appConfigService.get('serverPath')}Content/presentation_${this.props.type}.png")`
				}}
				/>
			);
		} else {
			return <i className={`fa fa-${icon} fa-${iconSize}x`} />;
		}
	}

	getThumb() {
		const thumbnailLinkUrl = this.getThumbnailLinkUrl();

		return this.props.customThumbnailUrl || thumbnailLinkUrl || decodeURIComponent(this.props.item.SourceContentImage);
	}

	getIconSize() {
		switch (this.props.type) {
			case 'tiny':
				return 1;
			case 'x-small':
			case 'small':
				return 2;
			case 'medium':
				return 3;
			case 'x-large':
				return 6;
			case 'xx-large':
				return 7;
			case 'xxx-large':
				return 8;
			default:
				return 5;
		}
	}

	getThumbnailLinkUrl() {
		return fileTypeService.thumbnailUrl(
			this.props.item.Type,
			this.props.item.ThumbnailLink,
			this.props.item.ExternalMediaID
		);
	}

	getMediaPreviewLink() {
		const {link, showBack, prevPage} = this.props;
		let queryStr = showBack ? '?showBack=true' : '';

		if (prevPage) {
			if (queryStr === '') {
				queryStr = `?prevPage=${prevPage}`;
			} else {
				queryStr = `${queryStr}&prevPage=${prevPage}`;
			}
		}

		return link + queryStr;
	}

	render() {
		const {link, className, target} = this.props;
		const mediaCardClassName = `media-card ${className}`;

		if (link) {
			return (
				<div className={mediaCardClassName}>
					<a className="undecorated" href={this.getMediaPreviewLink()} target={target}>
						{this.container()}
					</a>
				</div>
			);
		} else {
			return (
				<div className={mediaCardClassName}>
					{this.container()}
				</div>
			);
		}
	}
}

MediaPreview.propTypes = {
	item: PropTypes.object.isRequired,
	link: PropTypes.string,
	target: PropTypes.string,
	showBack: PropTypes.bool,
	showPlayIcon: PropTypes.bool,
	showTypeIndicator: PropTypes.bool,
	type: PropTypes.oneOf(['tiny', 'x-small', 'small', 'medium', 'large', 'x-large', 'xx-large', 'xxx-large', 'auto']),
	className: PropTypes.string,
	customThumbnailUrl: PropTypes.string,
	hideProducerIcon: PropTypes.bool,
	prevPage: PropTypes.string
};

MediaPreview.defaultProps = {
	type: 'large',
	className: '',
	hideProducerIcon: false,
	isCustomFile: false
};